<div class="toast-container">
  @for (toast of toasts; track toast.id) {
    <div 
      class="toast toast-{{ toast.type }}"
      [@slideInOut]
      (click)="removeToast(toast.id)"
    >
      <div class="toast-content">
        <ion-icon [name]="getIconName(toast.type) + '-outline'" class="toast-icon"></ion-icon>
        <span class="toast-message">{{ toast.message }}</span>
        <button 
          class="toast-close" 
          (click)="removeToast(toast.id); $event.stopPropagation()"
          aria-label="Close"
        >
          <ion-icon name="close-outline"></ion-icon>
        </button>
      </div>
    </div>
  }
</div>












